import { createContext } from 'preact'
import { useContext } from 'preact/hooks'
import type { AgentEffort } from '@/api/asset'

// Keyed by the generated AgentEffort union, so a level added to the C# enum fails this build until
// it has its copy here. The copy is product wording the enum doesn't carry, which is why this is not
// an App/Lookups endpoint. Listed in picker order.
const EFFORT_DESCRIPTIONS: Record<AgentEffort, string> = {
    Thorough: 'Best result, takes longest',
    Standard: 'Quicker, good for most edits',
    Fast: 'Quickest, for small wording or detail changes',
}

export const GENERATION_EFFORT_LEVELS: readonly { value: AgentEffort; description: string }[] =
    (Object.entries(EFFORT_DESCRIPTIONS) as [AgentEffort, string][]).map(([value, description]) => ({ value, description }))

export interface GenerationEffortControl {
    value: AgentEffort
    onChange: (effort: AgentEffort) => void
    // True while a change is being saved. The composer holds Send until it lands, so a message
    // sent mid-save cannot run at the level the user just moved away from.
    saving: boolean
}

/**
 * Provided by WebsterBuilderOverlay, which owns the asset the level is stored on. Null anywhere
 * else, so a composer outside the builder never offers a picker it has nothing to save to.
 */
export const GenerationEffortContext = createContext<GenerationEffortControl | null>(null)

export function useGenerationEffort(): GenerationEffortControl | null {
    return useContext(GenerationEffortContext)
}
